import styled from 'styled-components';
import { breakpoints } from '../../constants/styles';

const ImageQuery = styled.img.attrs(({ src }) => src)`
  width: 100%;
  height: auto;
  margin-bottom: ${({ marginBottom }) => (Number.isInteger(marginBottom) ? `${marginBottom}px` : marginBottom)};
  
  max-width: ${({ maxWidth }) => (Number.isInteger(maxWidth) ? `${maxWidth}px` : maxWidth)};
  ${({ styles }) => styles}

  &.mobileLandscape { display: none; }
  &.tabletPortrait { display: none; }
  &.tabletLandscape { display: none; }
  &.desktop { display: none; }
  &.larger { display: none; }

  ${breakpoints.mobileLandscape} {
    &.mobile { display: none; }
    &.mobileLandscape { display: block; }
    &.tabletPortrait { display: none; }
    &.tabletLandscape { display: none; }
    &.desktop { display: none; }
    &.larger { display: none; }
  }

  ${breakpoints.tablet} {
    &.mobile { display: none; }
    &.mobileLandscape { display: none; }
    &.tabletPortrait { display: block; }
    &.tabletLandscape { display: none; }
    &.desktop { display: none; }
    &.larger { display: none; }
  }

  ${breakpoints.tabletLandscape} {
    &.mobile { display: none; }
    &.mobileLandscape { display: none; }
    &.tabletPortrait { display: none; }
    &.tabletLandscape { display: block; }
    &.desktop { display: none; }
    &.larger { display: none; }
  }

  ${breakpoints.desktop} {
    &.mobile { display: none; }
    &.mobileLandscape { display: none; }
    &.tabletPortrait { display: none; }
    &.tabletLandscape { display: none; }
    &.desktop { display: block; }
    &.larger { display: none; }
  }

  ${breakpoints.larger} {
    &.mobile { display: none; }
    &.mobileLandscape { display: none; }
    &.tabletPortrait { display: none; }
    &.tabletLandscape { display: none; }
    &.desktop { display: none; }
    &.larger { display: block; }
  }
`;

export default ImageQuery;
